import PropTypes from 'prop-types';

import { useState } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import { Stack, TextField, Snackbar, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

CreateFeedback.propTypes = {
    student: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        email: PropTypes.string,
    }),
    success: PropTypes.func.isRequired,
};

export default function CreateFeedback({ student, success }) {
    const [text, setText] = useState('');
    const [error, setError] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

    const handleClick = () => {
        if (text !== '')
            api.post('feedback-api/create', { text, teacher_id: profile.data.id, student_id: student.id, email: student.email, course_id: 1 })
                .then((result) => {
                    if (result.id) success();
                    else if (result.status === "error") setError(result.message);
                })
                .catch((err) => {
                    api.logError('feedback failed', err);
                    setError('true');
                    setSnackbar({ open: true, message: err?.message || 'Помилка при відправці фідбеку', severity: 'error' });
                });
        else setError('true');
    };

    return (
        <>
            <Stack spacing={3}>

                <TextField multiline rows={5} name="text" label="Введіть текст" value={text} error={Boolean(error)}
                    onChange={(event) => {
                        setText(event.target.value);
                    }} />

                <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
                    Додати
                </LoadingButton>
            </Stack>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}
